/* 🤖 this file was generated by svg-to-ts */
export const matIconLeaderboard: {
  name: 'leaderboard';
  data: string;
} = {
  name: 'leaderboard',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 11V3H8v6H2v12h20V11h-6zm-6-6h4v14h-4V5zm-6 6h4v8H4v-8zm16 8h-4v-6h4v6z"/></svg>`
};
